<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">End Funding?</p>
      </header>
      <section class="modal-card-body">
        <div class="pa-xl has-text-centered">
          <p class="mb-sm">When you end funding, billable expenses can no longer be applied to this funding source.</p>
          <p>Are you sure you want to end funding?</p>
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >End Funding</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  computed: {
    ...mapGetters(['api', 'context'])
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/funding/' + this.$route.params.id + '/actions/end'
      this.$http.put(endpoint).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-success', message: 'Funding ended!' })
        this.$emit('funding:saved', response.data)
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  data () {
    return {
      saving: false,
      errors: []
    }
  },
  props: {
    funding: {
      type: Object,
      required: true
    }
  }
}
</script>
